export default "__VITE_ASSET__BlDxDWy2__"